/*
  CK Store — show the Arabic currency abbreviation (ر.ق) instead of "QAR"
  everywhere on the storefront when the page is in Arabic.

  Why this exists: Shopify's own "Change currency formatting" setting
  (Settings > General > Store currency) is a single, store-wide format used
  by every price on the site AND on Checkout. Checkout can't be changed per
  language, so that setting stays "QAR" there on purpose. This script only
  changes what shoppers see on the storefront pages (product, collection,
  cart, the bundle builder, etc.) while they're browsing in Arabic — it
  never touches Checkout, which isn't rendered by the theme at all.

  How: it walks visible text on the page and swaps the word "QAR" for "ر.ق"
  whenever the page's language is Arabic, then keeps watching for new price
  text that gets added later (cart drawer updates, the bundle builder
  picking a design, filters, etc.) so those get the swap too.
*/
(function () {
  function isArabicPage() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return lang.indexOf('ar') === 0 || document.documentElement.getAttribute('dir') === 'rtl';
  }

  if (!isArabicPage()) return;

  var AR_SYMBOL = 'ر.ق';
  var QAR_WORD = /\bQAR\b/g;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1 };

  function swapNode(node) {
    if (node.nodeType === 3) {
      if (node.nodeValue && node.nodeValue.indexOf('QAR') > -1) {
        node.nodeValue = node.nodeValue.replace(QAR_WORD, AR_SYMBOL);
      }
      return;
    }
    if (node.nodeType !== 1 || SKIP_TAGS[node.tagName]) return;
    var child = node.firstChild;
    while (child) {
      swapNode(child);
      child = child.nextSibling;
    }
  }

  function runFullSweep() {
    if (document.body) swapNode(document.body);
  }

  function watchForChanges() {
    if (!document.body || !('MutationObserver' in window)) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          swapNode(m.target);
        } else if (m.addedNodes) {
          for (var j = 0; j < m.addedNodes.length; j++) swapNode(m.addedNodes[j]);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function start() {
    runFullSweep();
    watchForChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();